import { StripeEnv } from '../../util/enums';
import { StripeError } from './errors';
import { vaultRequest } from './request';

const ATTACH_PAYMENT_METHOD_MUTATION = `
mutation VaultStripeConnectAccountPaymentMethodAttach(
    $paymentMethodId: String!
    $stripeConnectAccountId: String!
    $stripeEnv: VaultStripeEnv
    $customerId: String
  ) {
    response: vaultStripeConnectAccountPaymentMethodAttach(
      paymentMethodId: $paymentMethodId
      stripeConnectAccountId: $stripeConnectAccountId
      stripeEnv: $stripeEnv
      customerId: $customerId
    ) {
      errors {
        message
        type
      }
      success
    }
  }
  
`;

export const attachPaymentMethod = async (
  stripeConnectAccountId: string,
  customerId: string,
  paymentMethodId: string,
  stripeEnv?: StripeEnv,
): Promise<boolean> => {
  const attachPmRes = await vaultRequest(ATTACH_PAYMENT_METHOD_MUTATION, {
    stripeConnectAccountId,
    customerId,
    paymentMethodId,
    stripeEnv,
  });
  const attachPmResResJson = await attachPmRes.json();
  if (attachPmResResJson.errors && attachPmResResJson.errors.length > 0) {
    throw new StripeError(
      'Could not attach PM on Stripe Connect Account',
      attachPmResResJson.errors[0],
    );
  }
  return attachPmResResJson.data.response.success;
};
